module.exports = __webpack_public_path__ + "img/vehicle-maintenance-log-book_B09KN2MXZW.f35363df.jpg";